/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterItemDto } from './FilterItemDto';
import {
    FilterItemDtoFromJSON,
    FilterItemDtoFromJSONTyped,
    FilterItemDtoToJSON,
    FilterItemDtoToJSONTyped,
} from './FilterItemDto';

/**
 * 
 * @export
 * @interface GetContractFilterResponseDto
 */
export interface GetContractFilterResponseDto {
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetContractFilterResponseDto
     */
    products: Array<FilterItemDto>;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetContractFilterResponseDto
     */
    owners: Array<FilterItemDto>;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetContractFilterResponseDto
     */
    statuses: Array<FilterItemDto>;
}

/**
 * Check if a given object implements the GetContractFilterResponseDto interface.
 */
export function instanceOfGetContractFilterResponseDto(value: object): value is GetContractFilterResponseDto {
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('owners' in value) || value['owners'] === undefined) return false;
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    return true;
}

export function GetContractFilterResponseDtoFromJSON(json: any): GetContractFilterResponseDto {
    return GetContractFilterResponseDtoFromJSONTyped(json, false);
}

export function GetContractFilterResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractFilterResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(FilterItemDtoFromJSON)),
        'owners': ((json['owners'] as Array<any>).map(FilterItemDtoFromJSON)),
        'statuses': ((json['statuses'] as Array<any>).map(FilterItemDtoFromJSON)),
    };
}

export function GetContractFilterResponseDtoToJSON(json: any): GetContractFilterResponseDto {
    return GetContractFilterResponseDtoToJSONTyped(json, false);
}

export function GetContractFilterResponseDtoToJSONTyped(value?: GetContractFilterResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': ((value['products'] as Array<any>).map(FilterItemDtoToJSON)),
        'owners': ((value['owners'] as Array<any>).map(FilterItemDtoToJSON)),
        'statuses': ((value['statuses'] as Array<any>).map(FilterItemDtoToJSON)),
    };
}

